import { createContext, useContext, useSyncExternalStore } from 'react';
import type { AppEnvironment, AppState } from './AppEnvironment';

export const AppEnvironmentContext = createContext<AppEnvironment | null>(null);

/** Access the AppEnvironment instance (the wired auth+store singleton). */
export function useEnv(): AppEnvironment {
  const env = useContext(AppEnvironmentContext);
  if (!env) throw new Error('useEnv must be used within <AppEnvironmentContext.Provider>');
  return env;
}

/** Subscribe to the observable AppState — the analogue of reading @Observable. */
export function useAppState(): AppState {
  const env = useEnv();
  return useSyncExternalStore(env.subscribe, env.getState, env.getState);
}
